export const getBracketTextParts = (text = "") => {
	const parts = []
	const source = text == null ? "" : String(text)
	const bracketPattern = /\[([^\]]+)\]/g
	let lastIndex = 0
	let match

	while ((match = bracketPattern.exec(source)) !== null) {
		if (match.index > lastIndex) {
			parts.push({ text: source.slice(lastIndex, match.index) })
		}

		parts.push({ text: match[1], highlighted: true })
		lastIndex = match.index + match[0].length
	}

	if (lastIndex < source.length) {
		parts.push({ text: source.slice(lastIndex) })
	}

	return parts
}

export const getEstimatedArrivalParts = (text = "", date = "") => {
	const source = text == null ? "" : String(text)
	const placeholder = "(date)"
	const index = source.indexOf(placeholder)

	if (index === -1) {
		return [{ text: source }]
	}

	return [
		{ text: source.slice(0, index) },
		{ text: date, highlighted: true },
		{ text: source.slice(index + placeholder.length) },
	].filter((part) => part.text)
}

const decodeBasicHtmlEntities = (text = "") =>
	String(text)
		.replaceAll("&lt;", "<")
		.replaceAll("&gt;", ">")
		.replaceAll("&quot;", '"')
		.replaceAll("&#39;", "'")
		.replaceAll("&amp;", "&")

const escapeHtml = (text = "") =>
	String(text)
		.replaceAll("&", "&amp;")
		.replaceAll("<", "&lt;")
		.replaceAll(">", "&gt;")
		.replaceAll('"', "&quot;")
		.replaceAll("'", "&#39;")

export const getEstimatedArrivalHtml = (text = "", date = "") =>
	decodeBasicHtmlEntities(text).replaceAll("(date)", escapeHtml(date))
